import * as React from 'react'

interface LDMarkerProps {
  scope: string
}

// Because we're using componentDidMount
// the Click to Loaded (aka LD or ld) metric for async calls will correspond
// to the time after the react hydrate
class LDMarker extends React.Component<LDMarkerProps> {
  componentDidMount() {
    const script = document.createElement('script')
    const text = `if (window.ue && window.uex) { window.uex('ld', '${this.props.scope}', {wb:1}) }`
    script.innerHTML = text
    document.body.appendChild(script)
  }

  render(): any {
    return null
  }
}

export default LDMarker
